"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_1 = __importDefault(require("../../families/bitcoin/bridge/js"));
const js_2 = __importDefault(require("../../families/cardano/bridge/js"));
const js_3 = __importDefault(require("../../families/celo/bridge/js"));
const js_4 = __importDefault(require("../../families/cosmos/bridge/js"));
const js_5 = __importDefault(require("../../families/crypto_org/bridge/js"));
const js_6 = __importDefault(require("../../families/elrond/bridge/js"));
const js_7 = __importDefault(require("../../families/ethereum/bridge/js"));
const js_8 = __importDefault(require("../../families/filecoin/bridge/js"));
const js_9 = __importDefault(require("../../families/hedera/bridge/js"));
const js_10 = __importDefault(require("../../families/internet_computer/bridge/js"));
const js_11 = __importDefault(require("../../families/near/bridge/js"));
const js_12 = __importDefault(require("../../families/ripple/bridge/js"));
const js_13 = __importDefault(require("../../families/solana/bridge/js"));
const js_14 = __importDefault(require("../../families/stacks/bridge/js"));
const js_15 = __importDefault(require("../../families/stellar/bridge/js"));
const js_16 = __importDefault(require("../../families/tezos/bridge/js"));
const js_17 = __importDefault(require("../../families/tron/bridge/js"));
const setup_1 = require("../../families/algorand/setup");
const setup_2 = require("../../families/evm/setup");
const setup_3 = require("../../families/polkadot/setup");
exports.default = {
    bitcoin: js_1.default,
    cardano: js_2.default,
    celo: js_3.default,
    cosmos: js_4.default,
    crypto_org: js_5.default,
    elrond: js_6.default,
    ethereum: js_7.default,
    filecoin: js_8.default,
    hedera: js_9.default,
    internet_computer: js_10.default,
    near: js_11.default,
    ripple: js_12.default,
    solana: js_13.default,
    stacks: js_14.default,
    stellar: js_15.default,
    tezos: js_16.default,
    tron: js_17.default,
    algorand: setup_1.bridge,
    evm: setup_2.bridge,
    polkadot: setup_3.bridge,
};
//# sourceMappingURL=js.js.map